// TODO: move all helpdesk links here
export const HOW_TO_CANCEL = 'https://help.classpass.com/hc/articles/204578119-How-do-I-cancel-my-ClassPass-membership';
